import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";

export interface AttachInvestmentFilePayload {
  investmentUuid: string;
  fileUuid: string;
  role: "contract" | "photo" | "closure_contract";
}

export const useAttachInvestmentFile = (
  options?: UseMutationOptions<any, Error, AttachInvestmentFilePayload>
) => {
  return useMutation({
    ...options,
    mutationKey: ["attachInvestmentFile"],
    mutationFn: async (data: AttachInvestmentFilePayload) => {
      return axiosInstance
        .post(`/investments/${data.investmentUuid}/files`, {
          fileUuid: data.fileUuid,
          role: data.role,
        })
        .then((res) => res.data);
    },
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries({ queryKey: ["investments/grouped"] });
      if (options?.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error: any, variables, context) => {
      const is422 = error?.status === 422 || error?.response?.status === 422;
      Toast({
        message: is422
          ? "Osiągnięto limit 10 zdjęć dla tego aktywa."
          : "Błąd podczas dodawania pliku do aktywa.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "attach-investment-file",
      });
      if (options?.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
